var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('topTab',{attrs:{"changeTabIndex":3}}),_c('androidpage'),_c('bottomMsg')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }